import { Switch } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface Iprops {
  value: boolean;
  label: string;
  change: () => void;
  marginTop?: number;
  marginLeft?: number;
  defaultValue?: boolean;
}

const ToggleSwitch =  ({ value, label, change, marginTop = -14, marginLeft = -3, defaultValue }) => {
  // console.log('ToggleButton', value, label);
  const [checked, setChecked] = useState(value);

  useEffect(() => {
    // console.log('value---', value);
    setChecked(value);
  }, [value]);

  return (
    <Switch
      
      sx={{ marginTop: `${marginTop}px`, marginLeft: `${marginLeft}px` }}
      inputProps={{ 'aria-label': label }}
      checked={checked}
      defaultChecked={defaultValue}
      onChange={change}
      size="small"
      color='info'
    />
  );
};

export default ToggleSwitch;
